<template>
  <v-card elevation="7">
    <v-row class="bm-0 mb-0 pb-0">
      <v-col cols="12">
        <v-card-subtitle class="ml-2">
          <h2 class="text-uppercase indigo--text">
            {{ currentUser.nombre }} {{ currentUser.primer_apellido }} {{ currentUser.segundo_apellido }}
          </h2>
          <h4 class="text-uppercase" style="color: #616161">
            {{ currentUser.roles[0].descripcion }}
          </h4>
          <v-divider class="mt-3"/>
        </v-card-subtitle>
      </v-col>
      <v-col cols="12">
        <v-card class="mx-4" color="#CED7DB">
          <v-toolbar color="#286090" dark dense>
            <v-toolbar-title class="text-uppercase">Turno de Tocas</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mx-2">
      <v-spacer></v-spacer>
      <v-col cols="4" md="6" class="pt-0">
        <v-autocomplete
          :items = "listSalas"
          label="Seleccione una Sala"
          item-text="nombre"
          item-value="id"
          persistent-hint
          v-model="sala_id"
          required
          :rules="[v => !!v || 'Campo requerido']"
          key="id"
          :loading="loading"
          v-if="roleUser == 'superadmin' "
          @change="clearSearch()"
        />
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="5" class="pt-0" v-if="sala_id">
        <v-text-field
          placeholder="Buscar Toca"
          v-model="buscar"
          hint="Ej. 1/2023"
          :loading="loading"
          clearable
          @click:clear="clearSearch"
          v-on:keyup.enter="searchToca"
          append-outer-icon="mdi-magnify"
          @click:append-outer="searchToca"
          @keyup="buttons_on_alert = false"
        >
          <!-- @keyup="buttons_on_alert = false, btn_JO = false, btn_JT = false" -->
        </v-text-field>
      </v-col>
    </v-row>
    <!-- <div align="right" class="mr-13 mt-2">
      <v-btn small color="grey darken-2" dark
        v-if="btn_JT"
        @click="dialogFormToca=!dialogFormToca, tipo_juicio = 'JT'">
        Registrar Toca - Juicio Tradicional
      </v-btn>
      <v-btn small color="grey darken-2" dark
        v-if="btn_JO"
        @click="dialogFormToca=!dialogFormToca, tipo_juicio = 'JO'">
        Registrar Toca - Juicio Oral
      </v-btn>
    </div> -->
    <v-row class="mx-2 mt-0" v-if="sala_id">
      <v-col cols="12">
        <v-card class="mx-auto">
          <v-toolbar flat color="white">
            <v-toolbar-title class="d-none d-sm-flex">TOCAS</v-toolbar-title>
            <v-divider class="mx-4 pl-6 d-none d-sm-flex" inset vertical></v-divider>
            <v-select
              class="mt-7"
              :items="items_status"
              item-text="text"
              item-value="value"
              return-object
              label="Status"
              v-model="status"
              @change="numero='', anio='', buscar='', complemento='', current = 1, getTocas()"
            ></v-select>
          </v-toolbar>
          <div class="text-center mb-1">
            <v-toolbar-title>
              <h3 v-if="this.numero && this.anio">RESULTADOS DE LA BÚSQUEDA</h3>
              <h3 v-if="status.value==10">TOCAS PENDIENTES DE ADMISIÓN</h3>
              <h3 v-if="status.value==11">TOCAS ADMITIDAS</h3>
              <h3 v-if="status.value==12">TOCAS NO ADMITIDAS</h3>
              <h3 v-if="status.value==13">REGULARIZAR</h3>
            </v-toolbar-title>
          </div>
          <v-skeleton-loader
            v-if="!listTocas"
            type="article"
          ></v-skeleton-loader>

          <!-- MOSTRAR LISTADO -->
          <v-card v-if="listTocas && listTocas.length" v-for="(toca, i) in listTocas" :key="'toca_'+i">
            <v-toolbar-title style="background-color: #9c6f05;height: 45px;">
              <div class="text-center mb-1" style="color: white;margin-top: 8px;">
                <b>Toca: {{ toca.numero }}/{{ toca.anio }}
                  <span v-if="toca.complemento">-{{ toca.complemento}}</span>
                  ({{ toca.tipo_juicio == 'JO' ? 'Juicio Oral' : 'Jucio Tradicional' }})
                </b>
                <v-btn
                  v-if="roleUser == 'superadmin' "
                  style="float: right;"
                  icon
                  class="mt-n1 mr-2 ml-n11"
                  color="white"
                  @click="tipo_juicio = toca.tipo_juicio, editToca(toca)"
                >
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </div>
            </v-toolbar-title>
            <v-list v-if="listTocas">
              <span v-for="(apelacion, i) in toca.apelaciones"
                :key="apelacion.id">
                <v-list-group no-group>
                  <template v-slot:activator>
                    <div>
                      <b>FECHA DE RECEPCIÓN - <span>{{apelacion.fecha_recepcion | formatDate}}</span></b>
                    </div>
                    <v-spacer></v-spacer>
                    <v-chip
                      class="ma-2 font-weight-bold"
                      color="#607D8B"
                      label
                      text-color="white"
                      v-if="status.value!=10 &&
                            status.value!=11 &&
                            status.value!=12 &&
                            status.value!=13"
                      >
                      <v-icon left>
                        mdi-chevron-double-left
                      </v-icon>
                      <span v-if="apelacion.status == 10">
                        PENDIENTE DE ADMISIÓN
                      </span>
                      <span v-if="apelacion.status == 11">
                        ADMITIDA
                      </span>
                      <span v-if="apelacion.status == 12">
                        NO ADMITIDA
                      </span>
                      <span v-if="apelacion.status == 13">
                        PARA REGULARIZAR
                      </span>
                      <!-- <span v-if="item.status == 14">
                        CONTESTACIÓN NO ACEPTADA
                      </span> -->
                      <span v-if="apelacion.status == 30 ||
                                  apelacion.status == 40 ||
                                  apelacion.status == 41 ||
                                  apelacion.status == 42 ||
                                  apelacion.status == 43 ||
                                  apelacion.status == 44 "
                      >
                        EN PONENCIA
                      </span>
                      <span v-if="apelacion.status == 45">
                        CONCLUIDA
                      </span>
                      <span v-if="apelacion.status == 60">
                        SIN MATERIA
                      </span>
                      <span v-if="apelacion.status == 80">
                        DESISTIDA
                      </span>
                    </v-chip>
                    <v-btn
                      class="white--text ml-2"
                      color="#276090"
                      small
                      @click="verDocumentos(apelacion)"
                    >VER DOCUMENTOS
                    </v-btn>
                  </template>
                  <v-list-item-content>
                    <TableDetallesApelacion :apelacion="apelacion" />
                    <component v-if="apelacion.hash"
                      :is="eApelacion"
                      :hash="apelacion.hash"
                      :sala_id="currentUser.sala_id"
                      :index="apelacion.id">
                    </component>
                  </v-list-item-content>
                </v-list-group>
                <v-divider></v-divider>
                <!-- ACCIONES PARA EL TOCA -->
                <div v-if="![45, 13, 60, 80].includes(apelacion.status)" class="text-center font-weight-black mt-2 mb-n2">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="#276090"
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        Acciones
                      </v-btn>
                    </template>
                    <v-list>
                      <!-- Cada botón en su propio v-list-item -->
                      <v-list-item v-if="apelacion.status==10">
                        <v-btn
                          block
                          outlined
                          color="green"
                          @click="accionesToca(apelacion, 11), indexLoader=true"
                          :disabled="indexLoader"
                          small
                        >ADMITIR</v-btn>
                      </v-list-item>

                      <v-list-item v-if="apelacion.status==10">
                        <v-btn
                          block
                          outlined
                          color="red"
                          :loading="loading"
                          @click="accionesToca(apelacion, 12), indexLoader=true"
                          :disabled="indexLoader"
                          small
                        >NO ADMITIR</v-btn>
                      </v-list-item>

                      <v-list-item v-if="apelacion.status==11">
                        <v-btn
                          block
                          outlined
                          color="green"
                          :loading="loading"
                          @click="dialogTurnar=true, item_dialog = apelacion, item_dialog.toca = toca, indexLoader=true"
                          :disabled="indexLoader"
                          small
                        >TURNAR TOCA</v-btn>
                      </v-list-item>

                      <v-list-item v-if="![45, 13, 60, 80].includes(apelacion.status)">
                        <v-btn
                          block
                          outlined
                          color="orange"
                          :loading="loading"
                          @click="accionesToca(apelacion, 60), indexLoader=true"
                          :disabled="indexLoader"
                          small
                        >Sin Materia</v-btn>
                      </v-list-item>

                      <v-list-item v-if="![45, 13, 60, 80].includes(apelacion.status)">
                        <v-btn 
                          block
                          outlined
                          color="primary"
                          :loading="loading"
                          @click="accionesToca(apelacion, 80), indexLoader=true"
                          :disabled="indexLoader"
                          small
                        >Se desiste</v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </span>
            </v-list>
            <v-divider class="mt-2 mb-3"></v-divider>
          </v-card>
          <div class="text-center pt-2"  v-if="pageCount>1">
            <v-pagination
              v-model="current"
              :length="pageCount"
              :total-visible='7'
              @input="getTocas()"
            ></v-pagination>
          </div>

          <!-- MENSAJE NO HAY DATOS -->
          <v-alert v-if="listTocas && !listTocas.length"
            text
            outlined
            prominent
            type="error"
          >
            <v-row align="center">
              <v-col class="grow text-uppercase">
                <h4 v-if="status.value">No hay Tocas por mostrar!!!</h4>
                <h4 v-else>Toca no registrado!!!</h4>
              </v-col>
              <v-col class="shrink mt-n2 mb-n2"  v-if="numero && anio && buttons_on_alert">
                <!-- <v-btn small color="grey darken-2" dark
                  @click="tipo_juicio = 'JT', dialogFormToca=!dialogFormToca, accion_form_toca='add'">
                  Registrar Toca - Juicio Tradicional
                </v-btn>
                <br> -->
                <v-btn small color="grey darken-2" dark
                  style="min-width: 289px;"
                  @click="tipo_juicio = 'JO', dialogFormToca=!dialogFormToca, accion_form_toca='add'" class="mt-2">
                  Registrar Toca - Juicio Oral
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>

        </v-card>
      </v-col>
    </v-row>


    <!-- Dialog Asignar relator-magistrado -->
    <v-dialog
      v-model="dialogTurnar"
      persistent
      max-width="600px"
    >
      <Asignar
        v-if="dialogTurnar"
        :item="item_dialog"
        :status="item_dialog.status"
        :ponencias="getAllPonencias"
        :relatores="listRelatoresPonencia"
        @reloadTocas="getTocas()"
        @closeModal="dialogTurnar=false, indexLoader = false"
      ></Asignar>
    </v-dialog>
    <!-- Fin Dialog para Turnar -->

    <!-- Dialog componente FormToca -->
    <v-dialog
      persistent
      v-model="dialogFormToca"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    ><FormToca
        v-if="dialogFormToca"
        :sala_id="sala_id"
        :num_toca="buscar"
        :toca="toca_selected"
        :tipo_juicio="tipo_juicio"
        :accion="accion_form_toca"
        @reloadTocas="getTocas(), toca_selected=''"
        @closeModal="getTocas(), dialogFormToca=false, toca_selected=''"
      ></FormToca>
    </v-dialog>
    <!-- Fin Dialog componente FormToca -->

  </v-card>
</template>

<script>
  const Swal = require('sweetalert2');
  import FormToca from "../../components/FormToca";
  import ApelacionElectronica from "@/components/ApelacionElectronica";
  import Asignar from "../../components/Asignar";
  import TableDetallesApelacion from "@/components/TableDetallesApelacion";

  import { mapMutations } from "vuex";
  import { mapGetters } from "vuex";

  export default {
    components: {
       FormToca, ApelacionElectronica, Asignar, TableDetallesApelacion
    },
    props: {
      source: String
    },
    data() {
      return {
        valid: false,
        dialogFormToca: false,
        accion_form_toca: '',
        dialogTurnar:false,
        showAddBtn: false,
        listTocas: null,
        pageCount: 0,
        current:1,
        itemsPerPage: 20,
        toca_selected: '',
        tipo_juicio: '',
        // btn_JT: false,
        // btn_JO: false,
        buttons_on_alert: false,
        apelacion_selected: '',
        item_dialog:{},
        total:0,
        status: { "text": "PENDIENTES DE ADMISIÓN", "value": 10, "align": "", "sortable": true, "width": "" },
        loading: true,
        loadingTurnar: false,
        buscar: '',
        sala_id: '',
        anio:'',
        numero:'',
        complemento:'',
        items_status: [
          { text: "PENDIENTES DE ADMISIÓN", value: 10, align: "", sortable: true, width: '' },
          { text: "ADMITIDAS", value: 11, align: "", sortable: true, width: '' },
          { text: "NO ADMITIDAS", value: 12, align: "", sortable: true, width: '' },
          { text: "PARA REGULARIZAR", value: 13, align: "", sortable: true, width: '' },
          // { text: "CONTESTACION NO ACEPTADA", value: 14, align: "", sortable: true, width: '' },
          { text: "SIN MATERIA", value: 60, align: "", sortable: true, width: '' },
          { text: "DESISTIDAS", value: 80, align: "", sortable: true, width: '' },
        ],
        menu_fecha_citacion: false,
        menu_fecha_turno: false,
        fecha_citacion: "",
        fecha_turno: "",
        hash:"",
        eApelacion:"ApelacionElectronica",
        rules: {
          required:v => !!v || 'Campo requerido',
          requiredSelect:v => !!v|| 'Campo requerido'
        },
        indexLoader:false,
      };
    },
    computed: {
      ...mapGetters(["listSalas", "roleUser", "currentUser", "getAllPonencias", "listRelatoresPonencia"])
    },
    created() {
      // if (localStorage.getItem("currentApelacion")) {
      //   localStorage.removeItem("currentApelacion");
      // }
      this.$store.dispatch("GET_SALAS", { url: "salas" });
      this.$store.dispatch("GET_PONENCIAS", { url: "ponencias" });
      if (this.roleUser == 'superadmin') {
        this.loading = false
        return false;
      } else {
        let user = JSON.parse(localStorage.getItem('user'));
        this.sala_id = user.sala_id
      }
      this.getTocas();
    },
    methods: {
      getTocas(){
        this.pageCount = 0
        // this.dialogFormToca = false
        this.dialogReturno = false
        this.loading = true
        this.listTocas = null
        this.$store.dispatch("GET_TOCAS", {
          url: "/tocas/list",
          params: {
            page:this.current,
            apelacion_status:  this.status.value,
            sala_id:  this.sala_id,
            anio:  this.anio || undefined,
            numero:  this.numero || undefined,
            derivado:  this.complemento || undefined
          }
        }).then(response => {
          this.loading = false
          this.indexLoader = false
          this.buttons_on_alert = true
          this.current = response.data.data.toca.current_page;
          this.pageCount = response.data.data.toca.last_page;
          this.listTocas = response.data.data.toca.data || response.data.data.toca
          // this.checkButtons()
        });
      },
      searchToca(){
        if (!this.buscar) return false;
        if (this.buscar.length >= 5 ) {
          this.status = {}
          if ( this.buscar.includes("/") ) var tocacompleto = this.buscar.replace('/','');
          else var tocacompleto = this.buscar;

          this.complemento = tocacompleto.split('-').splice(1).join('-');
          var tocacompleto = tocacompleto.split('-')[0];
          this.anio = tocacompleto.substr(tocacompleto.length - 4);
          this.numero = tocacompleto.slice(0, tocacompleto.length - 4);

          if (this.anio && this.numero) {
             this.current = 1
             this.getTocas()
          } else {
            this.$swal({
              title: "Error",
              text: "Favor de verificar el formato del toca!!!",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        }
      },
      clearSearch () {
        this.showAddBtn = false
        this.numero = ''
        this.anio = ''
        this.status = { "text": "PENDIENTES DE ADMISIÓN", "value": 10, "align": "", "sortable": true, "width": "" }
        this.getTocas()
      },
      addTocaApelacion(toca){
        this.buscar = toca.numero + '/' + toca.anio
        this.toca_selected = toca
        this.accion_form_toca="add"
        this.dialogFormToca=true
      },
      editToca(toca){
        this.buscar = toca.numero + '/' + toca.anio
        this.toca_selected = toca
        this.accion_form_toca="edit"
        this.dialogFormToca=true
      },
      // addReturno(item){
        //   localStorage.setItem("currentApelacion", JSON.stringify(item.last_apelacion.id));
        //   this.$router.push('/returno')
        // },
        // addExcusa(toca){
        //   localStorage.setItem("excusarToca", JSON.stringify(toca.id));
        //   this.$router.push( {name:'ExcusarToca'} )
      // },
      accionesToca(apelacion, status){
        if (status == 11) {
          this.swalTitle = 'La apelación cambiará de estatus a "Admitida", ¿Deseas continuar?'
        }
        if (status == 12) {
          this.swalTitle = '¿Desea "No Admitir" la apelación?'
        }
        if (status == 60) {
          this.swalTitle = '¿Desea marcar como "Sin Materia" la apelación?'
        }
        if (status == 80) {
          this.swalTitle = '¿Desea "Desistir" la apelación?'
        }
        Swal.fire({
          title: this.swalTitle,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Continuar',
          confirmButtonColor: '#3085d6',
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            this.saveAdmision(apelacion, status)
          }else {
            this.indexLoader = false
          }
        })
      },
      saveAdmision(apelacion, status){
        var url = "/apelacion-admitir/" + apelacion.id
        if (status == 60) {
          url = "/apelacion/" + apelacion.id + "/sin-materia"
        }
        if (status ==80) {
          url = "/apelacion/" + apelacion.id + "/se-desiste"
        }
        this.indexLoader = true
        this.status_toca = status
        this.$store.dispatch("UPDATE_APELACION", {
          url: url,
          data:{
            status: this.status_toca
          }
        }).then(response => {
          if (response.status == 200) {
            if (this.status_toca == 11) { this.textSwal = 'Toca Admitida correctamente.' }
            if (this.status_toca == 12) { this.textSwal = 'Toca No Admitida.' }
            if (this.status_toca == 60) { this.textSwal = 'Toca marcada como Sin Materia.' }
            if (this.status_toca == 80) { this.textSwal = 'Toca marcada como Desistida.' }
            this.$swal({
              title: "Éxito",
              text: this.textSwal,
              icon: "success",
              confirmButtonText: "Aceptar"
            });
            this.getTocas()
          }
        }).catch(error => {
          if (error.response.data.status == 'Error documento admision') {
            Swal.fire({
              title: error.response.data.message,
              icon: 'error',
              showCancelButton: true,
              confirmButtonText: 'Continuar',
              cancelButtonText: 'Cancelar',
              reverseButtons: true
            }).then((result) => {
              if (result.isConfirmed) {
                this.indexLoader = false
                localStorage.setItem("currentApelacion", JSON.stringify( apelacion.id ));
                this.$router.push({name: 'MisDocumentos'});
              } else {
                this.indexLoader = false
              }
            })
          }
        });
      },
      verDocumentos(apelacion){
        localStorage.setItem("currentApelacion", JSON.stringify( apelacion.id ));
        this.$router.push({name: 'MisDocumentos'});
      }
    }
  };
</script>
